export default "__VITE_ASSET__CC24wRi8__"